<template>
  <div class="folder-content-view" :class="{ 'full-width': !collaborateVisible && !isTransitioning }">
    <div class="folder-article-view-section" ref="folderArticleViewSection">
      <div class="folder-article-view-section__header">
        <div class="folder-article-view-section__header--title">
          <button @click="visibleFolderSideBar" class="side-bar-menu">
            <img src="@/assets/icons/menu.svg" />
          </button>
          <div class="folder-icon">
            <img :src="parentFolder?.folder?.icon ??  require('@/assets/icons/glocal-folder-icon.svg')" alt="Icon" />
          </div>
          <a-tooltip :title="fullTitle" placement="bottomRight" overlayClassName="folders-title-tooltip">
            <h1
              v-if="parentFolder.folder || childFolder.folder || nestedChildFolder.folder"
              class="title"
            >
              <a-breadcrumb>
                <a-breadcrumb-item v-if="parentFolder.folder">{{ parentFolder.folder.name }}</a-breadcrumb-item>
                <a-breadcrumb-item v-if="childFolder.folder">{{ childFolder.folder.name }}</a-breadcrumb-item>
                <a-breadcrumb-item v-if="nestedChildFolder.folder">{{ nestedChildFolder.folder.name }}</a-breadcrumb-item>
                <!-- <span v-if="nestedChildFolder.folder">{{  nestedChildFolder.folder.name }}</span>
                  <span v-else-if="childFolder.folder">{{  childFolder.folder.name }}</span>
                  <span v-else>{{ parentFolder.folder.name}}</span> -->
              </a-breadcrumb>
            </h1>
          </a-tooltip>
        </div>
        <div class="folder-article-view-section__header--tabs-search">
          <div class="tabs" :class="{ 'tabs-scrollable': isTabsScrollable }" ref="tabsContainer">
            <button
              v-for="(tab, index) in tabs"
              :key="index"
              :class="{
                tabs__tab: true,
                'tabs__active-tab': activeTab === tab.id,
              }"
              @click="setActiveTab(tab.id)"
            >
              <span>{{ tab.label }}</span>
            </button>
          </div>
          <div class="search-container">
            <div class="search-container__users">
              <template v-if="folderUsers.length > 3">
                <button @click="openAllUsersModal()" class="see-all-users-btn">See all</button>
              </template>
              <template v-if="folderUsers.length > 0">
                <template v-for="(user, index) in folderUsers.slice(0, 3)" :key="index">
                  <img :src="user.profile_picture" alt="Image" class="img" v-if="user.profile_picture"/>
                </template>
              </template>
              <template v-if="inviteMembersPermission.includes(activeFolder?.permission)">
                <a-tooltip class="link-tooltip" placement="bottom">
                  <template #title>Invite</template>
                  <button class="add-btn" @click="toggleInviteCategoryModal()">
                    <img src="@/assets/icons/add-user-icon.svg">
                  </button>
                </a-tooltip>
              </template>
            </div>
            <div class="search-container__buttons">
              <!-- <a-tooltip class="link-tooltip" v-if="folderUsers.length > 0 && folderType === 'institute'">
                <template #title>Add Users</template>
                <button class="search-container__buttons--btn" @click="visibleUserPermissionDrawer()">
                  <img src="@/assets/icons/network_icon_black.png" />
                </button>
              </a-tooltip> -->
              <QRCode @click.stop :folder="QRDetails" />
              <!-- <a-tooltip class="link-tooltip">
                <template #title>Downloads</template>
                <button class="search-container__buttons--btn">
                  <img src="@/assets/icons/download-icon.png" />
                </button>
              </a-tooltip> -->
              <a-tooltip class="link-tooltip" v-if="folderType === 'institute'">
                <template #title>Activity Log</template>
                <button class="search-container__buttons--btn" @click="showActivityDrawer()">
                  <img src="@/assets/icons/activity-log-icon.png" />
                </button>
              </a-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="folder-article-view-section__body">
        <ArticleCollapseView :articleType="activeTab" v-if="activeTab === 'articles' || activeTab === 'suggested'" :collaborateToggle="collaborateVisible" :isTransitioning="isTransitioning" />
        <MediaSection v-if="activeTab === 'videos'  || activeTab === 'podcasts' || activeTab === 'books'" :isVideoContent="activeTab === 'videos' ? true : false" :isBookContent="activeTab === 'books' ? true : false" :collaborateToggle="collaborateVisible" :isTransitioning="isTransitioning" />
        <!-- <PodcastSection v-if="activeTab === 'podcasts'" :collaborateToggle="collaborateVisible" :isTransitioning="isTransitioning" /> -->
      </div>
    </div>
    <Transition name="slide-fade" @after-leave="afterLeave">
      <div v-if="collaborateVisible" class="collaborate-wrapper">
        <Collaborate discussionType="folder"/>
      </div>
    </Transition>
    <button class="collaborate-btn" @click="toggleCollaborate" :class="{ 'collaborate-btn-active': !collaborateVisible && !isTransitioning }">
      <img v-if="!collaborateVisible && !isTransitioning" src="@/assets/icons/discussion-icon-left.png" alt="Icon" width="auto" height="auto" />
      <img v-else src="@/assets/icons/discussion-icon-right.png" alt="Icon" width="auto" height="auto" />
    </button>
    <Transition name="slide-fade">
      <FolderMenuSidebar v-if="openFolderBar" />
    </Transition>
  </div>
  <!-- User permissions drawer -->
  <user-permissions-drawer
    :visibleDrawer="visibleUserPermissionsDrawer"
    :drawerPlacement="drawerPlacement"
    @close-drawer="closeUserPermissionsDrawer"
  >
  </user-permissions-drawer>
  <!-- Activity permissions drawer -->
  <activity-log-drawer 
   :drawerVisibility="activityDrawer"
    @close-drawer="closeActivityDrawer()"
  >
  </activity-log-drawer>

  <InviteFolder
    :visible="inviteCategoryModal"
    @handle-close="inviteCategoryModal = false"
    :options="[]"
    :categoryId="folderId"
    :inviteType="'folderInvite'"
    :folderId="selectedFolderId"
  ></InviteFolder>

  <all-users-modal
    :visible="visibleAllUsersModal"
    :users="folderUsers"
    @closeAllUserModal="closeAllUsersModal"
  >
  </all-users-modal>
</template>

<script>
import MediaSection from "./MediaSection.vue";
import QRCode from "../BaseComponents/QRCodeScanner/QRCode.vue";
import FolderMenuSidebar from "./FolderMenuSidebar.vue";
import ArticleCollapseView from "./ArticleCollapseView.vue";
// import PodcastSection from "./PodcastSection.vue";
import UserPermissionsDrawer from "./UserPermissionsDrawer.vue";
import ActivityLogDrawer from "./ActivityLogDrawer.vue";
import foldersMixin from "../../mixins/folders.mixnin";
import Collaborate from "../PdbComponents/Collaborate.vue";
import InviteFolder from '@/components/PdbComponents/InviteToDiscussionModal.vue';
import { mapGetters, mapActions } from 'vuex';
import AllUsersModal from "../BaseComponents/AllUsersModal.vue";
import { onBeforeUnmount } from 'vue';

export default {
  data() {
    return {
      openFolderBar: false,
      activeTab: "articles",
      visibleUserPermissionsDrawer: false,
      activityDrawer: false,
      tabs: [
        { id: "articles", label: "Articles" },
        { id: "videos", label: "Videos" },
        { id: "podcasts", label: "Podcasts" },
        { id: "books", label: "Books" },
        { id: "suggested", label: "Suggested Articles by Glocal" },
      ],
      collaborateVisible: false,
      isTransitioning: false,
      inviteCategoryModal: false,
      visibleAllUsersModal: false,
      inviteMembersPermission: ['admin', 'editor'],
      isTabsScrollable: false, // New data property for scroll detection
      resizeTimeout: null, // For debouncing resize events
      tabsObserver: null, // ResizeObserver instance
    };
  },
  mixins:[foldersMixin],
  components: {
    FolderMenuSidebar,
    QRCode,
    MediaSection,
    ArticleCollapseView,
    // PodcastSection,
    UserPermissionsDrawer,
    ActivityLogDrawer,
    Collaborate,
    InviteFolder,
    AllUsersModal
  },
  created(){
    const collapsedState = this.authUser?.profile?.settings?.is_folder_topic_collaborate_collapsed ?? true
    this.collaborateVisible = collapsedState
    if (window.innerWidth <= 786)
      this.collaborateVisible = false
  },
  mounted() {
    this.emitter.on("close-folder-side-bar", () => {
      this.openFolderBar = false;
    });
    
    // Check for tabs scrollability on mount
    this.$nextTick(() => {
      this.checkTabsScrollability();
    });
    
    // Add resize listener to check scrollability on window resize
    // Scroll Pagination Code
    window.addEventListener('resize', this.handleResize);
    
    // Mutation observer to watch for DOM changes
    this.observeTabsContainer();

    this.$nextTick(() => {
      const container = this.$refs.folderArticleViewSection;

      const handleScroll = () => {
        const isMobile = window.innerWidth < 768;

        const scrollTop = isMobile
          ? window.pageYOffset || document.documentElement.scrollTop
          : container.scrollTop;

        const clientHeight = isMobile
          ? window.innerHeight
          : container.clientHeight;

        const scrollHeight = isMobile
          ? document.documentElement.scrollHeight
          : container.scrollHeight;

        const scrollPosition = scrollTop + clientHeight;

        if (scrollPosition >= scrollHeight - 100 && !this.skeletonLoader) {
          this.incOrDecFolderContentPageCounter({ action: 'inc', content: this.activeTab });
        }
      };

      // Listen to scroll based on screen size
      if (window.innerWidth < 768) {
        window.addEventListener('scroll', handleScroll);
      } else {
        container.addEventListener('scroll', handleScroll);
      }

      // Cleanup
      onBeforeUnmount(() => {
        if (window.innerWidth < 768) {
          window.removeEventListener('scroll', handleScroll);
        } else {
          container.removeEventListener('scroll', handleScroll);
        }
      });
    });
  },
  beforeUnmount() {
    // Clean up resize listener
    window.removeEventListener('resize', this.handleResize);
    
    // Clean up mutation observer
    if (this.tabsObserver) {
      this.tabsObserver.disconnect();
    }
  },
  watch:{
    '$route.params.id': {
      handler: function() {
        this.activeTab = 'articles'
        // Recheck scrollability when route changes
        this.$nextTick(() => {
          this.checkTabsScrollability();
        });
      },
      deep: true,
      immediate: true
    },
    collaborateVisible: {
      handler(val) {
        if(val) {
          this.$nextTick(() => {
            this.emitter.emit('lock-scroll', true)
          })
        } else {
          this.emitter.emit('lock-scroll', false)
        }
        
        // Recheck scrollability when collaborate panel toggles
        this.$nextTick(() => {
          this.checkTabsScrollability();
        });
      }, 
      immediate: true
    },
    // Watch for tabs array changes
    tabs: {
      handler() {
        this.$nextTick(() => {
          this.checkTabsScrollability();
        });
      },
      deep: true
    },
    activeTab: {
      handler(tabName) {
        /// initial article loading is done in Folder sidebar
        switch (tabName) {
          case 'articles':
            this.resetFolderArticlePage()
            this.$store.commit("folders/SET_FOLDER_ARTICLE_CONTENT", []);
            this.getFolderArticleContent({folderId: this.folderId, contentType: 'article'})
            break;
          case 'videos':
            this.resetFolderMediaPage()
            this.$store.commit("folders/SET_FOLDER_MEDIA_CONTENT", []);
            this.getFolderMediaContent({folderId: this.folderId, contentType: 'video'})
            break;
          case 'podcasts':
            this.resetFolderPodcastPage()
            this.$store.commit("folders/SET_FOLDER_PODCASTS_CONTENT", []);
            this.getFolderPodcastContent({folderId: this.folderId, contentType: 'podcast'})
            break;
          case 'books':
            this.resetFolderBookPage()
            this.$store.commit("folders/SET_FOLDER_BOOKS_CONTENT", []);
            this.getFolderBooksContent({folderId: this.folderId, contentType: 'book'})
            break;
          case 'suggested':
            this.resetFolderSuggestedArticlePage()
            this.$store.commit("folders/SET_FOLDER_SUGGESTED_ARTICLE_CONTENT", []);
            this.getFolderSuggestedArticles(this.activeFolder?.name)
            break;
          default:
            break;
        }
      }
    },
    folderArticleContentPage:{
      handler(val){
        if (val){
          if (val > 1){
            this.getFolderArticleContent({folderId: this.folderId, contentType: 'article', isSkeletonLoader:false})
          }
        }
      },
    },
    folderMediaContentPage: {
      handler(val) {
        if (val && this.activeTab === 'videos') {
          if (val > 1) {
            this.getFolderMediaContent({
              folderId: this.folderId, 
              contentType: 'video', 
              isSkeletonLoader: false
            }).catch(err => {
              console.error('Error loading more videos:', err);
              // Roll back the page increment if the request fails
              this.incOrDecFolderContentPageCounter({ action: 'dec', content: 'videos' });
              
              // Show user feedback if needed
              if (err.response && err.response.status === 404) {
                this.$message.error('Could not load more videos. The endpoint may not be available.');
              }
            });
          }
        }
      },
    },
    folderBookContentPage: {
      handler(val) {
        if (val && this.activeTab === 'books') {
          if (val > 1) {
            this.getFolderBooksContent({folderId: this.folderId, contentType: 'book', isSkeletonLoader: false})
          }
        }
      },
    },
    folderPodcastContentPage: {
      handler(val) {
        if (val && this.activeTab === 'podcasts') {
          if (val > 1) {
            this.getFolderPodcastContent({folderId: this.folderId, contentType: 'podcast', isSkeletonLoader: false})
          }
        }
      },
    },
    folderSuggestedArticlePage: {
      handler(val) {
        if (val && this.activeTab === 'suggested') {
          console.log("SHOEULD", val)
          this.getFolderSuggestedArticles(this.activeFolder?.name)
            .catch(err => {
              console.error('Error loading suggested articles:', err);
              // Show user-friendly error message
              this.$message.error('Failed to load more suggested articles');
              // Roll back page increment
              this.incOrDecFolderContentPageCounter({
                action: 'dec',
                content: 'suggested'
              });
            });
        }
      },
    },
  },
  methods: {
    ...mapActions({
      updateUserSettings: 'profile/updateUserSettings',
      getFolderArticleContent: 'folders/fetchFolderArticles',
      getFolderMediaContent: 'folders/fetchFolderMedia',
      getFolderPodcastContent: 'folders/fetchFolderFiles',
      getFolderBooksContent: 'folders/fetchFolderBooks',
      getFolderSuggestedArticles: 'folders/fetchFolderSuggestedArticles',
      incOrDecFolderContentPageCounter: 'folders/incOrDecFolderContentPageCounter',
      resetFolderArticlePage: 'folders/resetFolderArticlePage',
      resetFolderMediaPage: 'folders/resetFolderMediaPage',
      resetFolderBookPage: 'folders/resetFolderBookPage',
      resetFolderPodcastPage: 'folders/resetFolderPodcastPage',
      resetFolderSuggestedArticlePage: 'folders/resetFolderSuggestedArticlePage',
    }),
    
    // New method to check if tabs are scrollable
    checkTabsScrollability() {
      if (this.$refs.tabsContainer) {
        const container = this.$refs.tabsContainer;
        const wasScrollable = this.isTabsScrollable;
        this.isTabsScrollable = container.scrollWidth > container.clientWidth;
        
        // Debug log to see what's happening
        // console.log('Checking tabs scrollability:', {
        //   scrollWidth: container.scrollWidth,
        //   clientWidth: container.clientWidth,
        //   isScrollable: this.isTabsScrollable,
        //   wasScrollable
        // });
      }
    },
    
    // Debounced resize handler
    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.checkTabsScrollability();
      }, 100);
    },
    
    // Observe tabs container for changes
    observeTabsContainer() {
      if (this.$refs.tabsContainer && 'ResizeObserver' in window) {
        this.tabsObserver = new ResizeObserver(() => {
          this.checkTabsScrollability();
        });
        this.tabsObserver.observe(this.$refs.tabsContainer);
      }
    },
    
    visibleFolderSideBar() {
      this.openFolderBar = true;
    },
    setActiveTab(tabId) {
      this.activeTab = tabId;
    },
    visibleUserPermissionDrawer() {
      if (window.innerWidth < 576) {
        this.drawerPlacement = 'bottom'
      } else if (window.innerWidth > 576) {
        this.drawerPlacement = 'right'
      }
      this.visibleUserPermissionsDrawer = true
    },
    closeUserPermissionsDrawer() {
      this.visibleUserPermissionsDrawer = false
    },
    showActivityDrawer() {
      this.activityDrawer = true
    },
    closeActivityDrawer() {
      this.activityDrawer = false
    },
    toggleCollaborate() {
      this.isTransitioning = true;
      this.collaborateVisible = !this.collaborateVisible;
      const userSettings = this.authUser?.profile?.settings
      userSettings.is_folder_topic_collaborate_collapsed = this.collaborateVisible
      this.updateUserSettings({settings: userSettings, user_id:this.authUser?.id})
      
      // Recheck scrollability after toggle
      this.$nextTick(() => {
        this.checkTabsScrollability();
      });
    },
    afterLeave() {
      // After the leave transition, reset the flag to allow full-width
      this.isTransitioning = false;
      // Recheck scrollability after transition
      this.$nextTick(() => {
        this.checkTabsScrollability();
      });
    },
    toggleInviteCategoryModal(){
      this.inviteCategoryModal = !this.inviteCategoryModal
    },
    async openAllUsersModal() {
      this.visibleAllUsersModal = true;
    },
    closeAllUsersModal() {
      this.visibleAllUsersModal = false;
    },
  },
  computed: {
    ...mapGetters({
      authUser: 'profile/userInformation',
      folderDiscussionUsers: 'folders/getUsersWithFolderAccess',
      activeFolder: 'folders/activeFolder',
      folderArticleSkeleton: 'folders/folderArticleSkeleton',
      folderArticleContentPage: 'folders/folderArticleContentPage',
      hasReachedFolderArticleContentLimit: 'folders/hasReachedFolderArticleContentLimit',
      folderMediaSkeleton: 'folders/folderMediaSkeleton',
      folderMediaContentPage: 'folders/folderMediaContentPage',
      hasReachedFolderMediaContentLimit: 'folders/hasReachedFolderMediaContentLimit',
      folderBookContentPage: 'folders/folderBookContentPage',
      hasReachedFolderBookContentLimit: 'folders/hasReachedFolderBookContentLimit',
      folderPodcastContentPage: 'folders/folderPodcastContentPage',
      hasReachedFolderPodcastContentLimit: 'folders/hasReachedFolderPodcastContentLimit',
      folderSuggestedArticlePage: 'folders/folderSuggestedArticlePage',
      hasReachedFolderSuggestedArticleLimit: 'folders/hasReachedFolderSuggestedArticleLimit',
      folderSuggestedArticleSkeleton: 'folders/folderSuggestedArticleSkeleton'
    }),
    activeComponent() {
      return this.components[this.activeTab];
    },
    parentFolder() {
      return this.$store.getters["folders/getParentFolderDetails"];
    },
    childFolder() {
      return this.$store.getters["folders/getChildFolderDetails"];
    },
    nestedChildFolder() {
      return this.$store.getters["folders/getNestedChildFolderDetails"];
    },
    folderUsers() {
      return this.$store.getters["folders/getUsersWithFolderAccess"].filter(user=>user?.status === 'accepted');
    },
    QRDetails() {
      let folder = this.childFolder.folder
        ? this.childFolder.folder
        : this.parentFolder.folder;
      return folder;
    },
    folderId(){
      return this.$route.params.id
    },
    fullTitle() {
      return [
        this.parentFolder.folder?.name,
        this.childFolder.folder?.name,
        this.nestedChildFolder.folder?.name
      ].filter(Boolean).join(" / ");
    },
    skeletonLoader() {
      if(this.activeTab === 'articles') {
        return this.folderArticleSkeleton;
      } 
      else if (this.activeTab === 'suggested'){
        return this.folderSuggestedArticleSkeleton
      }      
      else if(this.activeTab === 'videos' || this.activeTab === 'podcasts' || this.activeTab === 'books') {
        return this.folderMediaSkeleton;
      } else {
        return false;
      }
    }
  },
};
</script>

<style lang="scss">
.folder-content-view {
  display: grid;
  grid-template-columns: 60% 40%;
  position: relative;
  &.full-width {
    grid-template-columns: 100% !important;
  }
  // Responsive adjustments
  @include respond(laptop-medium) {
    grid-template-columns: 58% 42%;
  }
  @media (max-width: 1199px) {
    grid-template-columns: 100%;
  }
  .folder-article-view-section {
    height: calc(100vh - 8rem);
    overflow-y: auto;
    overflow-x: hidden;
    @include respond(tab-port) {
      height: 100%;
      overflow: hidden;
    }
    &__header {
      padding: 2rem 2.5rem 0;
      margin-bottom: 2rem;
      position: sticky;
      top: 0;
      background-color: $color-white;
      z-index: 22;
      border-bottom: 1px solid $color-dark-grey-5;
      @include respond(tab-port) {
        padding: 1.9rem 2rem 0;
        position: fixed;
        top: 7.5rem;
        margin-bottom: 0;
        width: 100%;
      }
      @include respond(phone-x-small) {
        padding: 1.9rem 2.4rem 0;
        top: 10.5rem;
      }
      &--title {
        display: flex;
        align-items: center;
        min-width: fit-content;
        min-height: 2.4rem;
        max-width: 100%;
        .side-bar-menu {
          display: none;
          margin-right: 2.5rem;
          line-height: normal;
          padding: 0;
          height: fit-content;
          width: fit-content;
          border: none;
          background-color: transparent;
          color: $color-black;
          outline: none;
          cursor: pointer;
          @include respond(tab-port) {
            display: block;
          }
          img {
            width: 3.2rem;
          }
        }
        .folder-icon {
          margin-right: 2rem;
          width: 2.2rem;
          height: 2.2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          font-size: 2rem;
          font-family: $font-primary-medium;
          line-height: 2.4rem;
          color: $color-black;
          margin-bottom: 0;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1; /* number of lines to show */
                  line-clamp: 1; 
          -webkit-box-orient: vertical;
          max-width: calc(100% - 3.2rem);
          @include respond(tab-port) {
            max-width: calc(100% - 10.2rem);
          }
          .ant-breadcrumb {
            font-size: 2rem;
            line-height: 2.4rem;
          }
        }
      }
      &--tabs-search {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 3rem;
        @media (max-width: 1199px) {
          margin-top: 2.6rem;
        }
        @include respond(tab-port) {
          padding: 2rem 0 0;
        }
        .tabs-scrollable {
          margin-top: -0.4rem;
        }
        .tabs {
          width: auto;
          display: flex;
          align-items: center;
          gap: 1.6rem;
          overflow-x: auto;
          overflow-y: hidden;
          &__tab {
            padding: 1.2rem 1.6rem 1rem;
            display: flex;
            align-items: center;
            width: max-content;
            justify-content: center;
            border: none;
            outline: none;
            background-color: $color-light-grey-3;
            font-size: 1.4rem;
            font-family: $font-primary-medium;
            line-height: normal;
            color: $color-dark-grey-6;
            border-top-right-radius: 1rem !important;
            border-top-left-radius: 1rem !important;
            border-bottom-left-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
            cursor: pointer;
            margin-bottom: 0;
            height: 4rem;
            span {
              display: block;
              width: max-content;
              line-height: normal;
              margin-bottom: -0.1rem;
            }
          }
          &__active-tab {
            background-color: $color-primary;
            color: $color-white;
          }
          &::-webkit-scrollbar {
            height: 0.4rem;
          }

          &::-webkit-scrollbar-track {
            background-color: $color-light-grey-3;
            border-radius: 0.8rem;
            height: 0.4rem;
          }

          &::-webkit-scrollbar-thumb {
            background-color: $color-primary;
            border-radius: 0.8rem;
          }

          @include respond(phone-x-small) {
            &::-webkit-scrollbar {
              display: none;
            }
          }
        }
        .search-container {
          width: auto;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 1.2rem;
          margin-bottom: 0;
          padding-left: 3.5rem;
          margin-top: -0.7rem;
          &__users {
            display: flex;
            align-items: center;
            .img {
              width: 4.6rem;
              height: 4.6rem; 
              border-radius: 100%;
              background-color: #e6e7e9;
              margin-left: -2rem;
            }
            .add-btn {
              width: 4.6rem;
              height: 4.6rem;
              border-radius: 100% !important;
              background-color: #e1e8ff;
              display: flex;
              align-items: center;
              outline: none;
              border: none;
              justify-content: center;
              cursor: pointer;
              margin-left: -2rem;
              img {
                width: 2.5rem;
              }
            }
            .see-all-users-btn {
              width: max-content;
              height: max-content;
              background-color: transparent;
              border-radius: 100% !important;
              display: flex;
              align-items: center;
              justify-content: center;
              border: none;
              outline: none;
              margin-right: 2.5rem;
              font-size: 1.6rem;
              line-height: normal;
              cursor: pointer;
              color: $color-black;
            }
          }
          &__buttons {
            display: flex;
            align-items: center;
            gap: 1.6rem;
            &--btn {
              width: 4.6rem;
              height: 4.6rem;
              border: none;
              outline: none;
              border-radius: 100% !important;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: $color-white;
              cursor: pointer;
              background-color: #e1e8ff;
              img {
                width: 1.8rem;
                height: auto;
              }
            }
            .qr-code-scanner-container {
              &__btn {
                width: 4.6rem;
                height: 4.6rem;
                background-color: #e1e8ff;
                img {
                  width: 1.8rem;
                  height: auto;
                }
              }
              &__scanner-dropdown {
                top: 7rem;
                right: -0.5rem;
              }
            }
          }
          &__search-bar {
            border: 1px solid $color-dark-grey-5;
            display: flex;
            align-items: center;
            padding: 0 1.8rem;
            border-radius: 100px;
            width: calc(100% - 136px);
            background-color: #efefef;
            max-width: 30rem;
            .icon {
              font-size: 1.7rem;
              color: $color-primary;
            }
            .icon-add_plus {
              transform: rotate(45deg);
              display: block;
              font-size: 1.4rem;
              color: $color-black;
              cursor: pointer;
            }
            .search-bar {
              border: none;
              padding: 0;
              padding-left: 1.3rem;
              background-color: transparent;
              height: 5.1rem;
              font-size: 1.4rem;
              outline: none;
              border: none;
              padding-right: 1rem;
              width: 100%;
              &::placeholder {
                color: $color-placeholder;
              }
            }
          }
        }
      }
    }
    &__body {
      padding: 0 2.5rem 2rem;
      @include respond(tab-port) {
        padding: 0 2rem 2.5rem;
        margin-top: 17rem;
      }
      @include respond(phone-x-small) {
        padding: 0 2.4rem 1.5rem;
      }
    }
    &::-webkit-scrollbar {
      width: 0.3rem;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 0.8rem;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $color-primary;
      border-radius: 0.8rem;
      height: 5rem;
    }
  }
  .collaborate-wrapper {
    position: relative;

    .collaborate-container {
      &__body {
        &--search-bar {
          .input.expanded {
            width: calc(100% - 4rem);
            @include respond(tab-port) {
              width: calc(100% - 5.5rem);
            }
          }
        }
      }
    }
    
    .collaborate-container {
      position: absolute;
      right: 2.5rem;
      bottom: 2rem;
      width: calc(100% - 5rem);
      margin: 0;
      z-index: 333;
      background-color: $color-white;
      
      // Desktop large screens (1281px and above)
      @media (min-width: 1281px) {
        height: calc(100vh - 15rem);
        
        &__body {
          height: calc(100vh - 30.5rem);
        }
      }
    }

    // Tablet landscape
    @media (max-width: 1199px) {
      position: absolute;
      height: calc(100vh - 13rem);
      right: 2.5rem;
      bottom: 0;
      width: calc(100% - 5rem);
      margin: 0;
      z-index: 333;
      background-color: $color-white;
      
      .collaborate-container {
        width: 100%;
        right: 0;
        height: calc(100vh - 16rem);
      }
    }

    // Tablet portrait
    @include respond(tab-port) {
      height: calc(100% - 6rem);
      top: 6rem;
      right: 2rem;
      width: calc(100% - 4rem);
      
      .collaborate-container {
        top: 0;
        height: calc(100vh - 18rem);
      }
    }

    // Small phones
    @include respond(phone-x-small) {
      height: calc(100% - 6rem);
      top: 6rem;
      right: 2.3rem;
      width: calc(100% - 4.7rem);
      
      .collaborate-container {
        width: 100%;
        height: calc(100vh - 32rem);
        bottom: 4rem;
        
        &__body {
          height: calc(100vh - 48.5rem);
        }
      }
    }
  }
  .collaborate-btn {
    background-color: #ebebeb;
    cursor: pointer;
    z-index: 334;
    outline: none;
    width: 4rem;
    height: 4rem;
    border-radius: 100% !important;
    position: absolute;
    top: 27rem;
    right: calc(40% - 4.5rem);
    transition: all .3s ease-in-out;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
    border: none;
    img {
      width: 100%;
      height: auto;
    }
    @include respond(laptop-medium) {
      right: calc(40% - 2.2rem);
    }
    @media (max-width: 1199px) {
      left: 1rem;
    }
    @include respond(tab-port) {
      top: 35rem;
    }
    @include respond(phone-x-small) {
      width: 6rem;
      height: 6rem;
      position: fixed;
      top: 45rem !important;
      left: 0.3rem;
    }
  }
  .collaborate-btn-active {
    background-color: #e1e8ff;
    right: 3rem;
    left: unset;
    @include respond(tab-port) {
      right: 2rem !important;
    }
    @include respond(phone-x-small) {
      right: 0.5rem !important;
    }
  }
}


.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
  transform: translateX(-100%);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
.folders-title-tooltip {
  max-width: 50rem;
  .ant-tooltip-inner {
    padding: 0.8rem 1.7rem !important;
  }
}
</style>
